
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Helmet } from 'react-helmet-async';

const Login = () => {
    const [form, setForm] = useState({ username: '', password: '' });
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Static admin credentials
    const ADMIN_USER = 'admin';
    const ADMIN_PASS = 'admin123';

    const handleChange = e => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setError('');
    };

    const handleSubmit = e => {
        e.preventDefault();
        if (form.username === ADMIN_USER && form.password === ADMIN_PASS) {
            setError('');
            navigate('/all-results');
        } else {
            setError('Invalid username or password');
        }
    };

    return (
        <>
            <Helmet>
                <title>Admin Login – ISJS 2025 Jewellery Show Portal</title>
                <meta name="description" content="Login to your ISJS 2025 admin account." />
            </Helmet>
            <Header />
            <div className='login-container'>
                <section className="h-screen">
                    <div className="container">
                        <div className="col-md-4 login-form-box">
                            <div className="sec-title"><h2>Admin Login</h2><div className="separator"></div></div>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <input
                                        type="text"
                                        className="form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        placeholder="Username"
                                        name="username"
                                        value={form.username}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <input
                                        type="password"
                                        className="form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        placeholder="Password"
                                        name="password"
                                        value={form.password}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    Login
                                </button>
                                {error && <div style={{ color: 'red', marginTop: 16, fontWeight: 500 }}>{error}</div>}
                            </form>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    );
};

export default Login;